import { render, staticRenderFns } from "./BigPlatform.vue?vue&type=template&id=6d7456df&scoped=true"
import script from "./BigPlatform.vue?vue&type=script&lang=js"
export * from "./BigPlatform.vue?vue&type=script&lang=js"
import style0 from "./BigPlatform.vue?vue&type=style&index=0&id=6d7456df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7456df",
  null
  
)

export default component.exports